<script setup lang="ts">
import { RouterView } from 'vue-router'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import appCommunication from './services/app-communication'
import alert from './services/alert'

// @local-testing: remove before committing
// if (import.meta.env.DEV && !window.nativeApp) {
//   const map: Record<string, unknown> = {
//     'access-token': 'd8a1ab6910758197820ab8281bc1563b',
//     language: 'ar',
//     'user-id': '373',
//     'device-model': 'iPhone12,1',
//     'device-os-version': '17',
//     'app-version': '266',
//     'ride-id': null,
//     location: [24.818594, 46.788464]
//   }
//   window.nativeApp = {
//     postMessage: (message: unknown) => {
//       let key: string
//       try {
//         const parsed =
//           typeof message === 'string' && message.startsWith('{') ? JSON.parse(message) : null
//         key = parsed ? parsed.type : message
//       } catch {
//         key = message as string
//       }
//       console.log('[nativeApp mock]', key, '→', map[key] ?? null)
//       return Promise.resolve(map[key] ?? null)
//     }
//   }
//   window.webkit = { messageHandlers: { nativeApp: window.nativeApp } } as typeof window.webkit
// }

const { locale } = useI18n({ useScope: 'global' })
const isInitialized = ref(false)

onMounted(async () => {
  try {
    await appCommunication.initializeCommunication()
    const lang = await appCommunication.getLanguage()
    locale.value = lang
    isInitialized.value = true
  } catch (error) {
    console.error('Failed to initialize app communication:', error)
    alert.error('please update your app to latest version')
  }
})
</script>

<template>
  <div v-if="isInitialized" :dir="locale === 'ar' ? 'rtl' : 'ltr'" :lang="locale">
    <RouterView />
  </div>
  <div v-else>
    <div>Loading...</div>
  </div>
</template>

<style>
.pointer {
  cursor: pointer;
}
.pointer:hover {
  background-color: rgb(228, 226, 223);
}

.text-dark-blue {
  color: #2d3647;
}
.bg-dark-blue {
  background-color: #2d3647;
}
.border-dark-blue {
  border-color: #2d3647;
}

.text-light-blue {
  color: #44d3f4;
}
.bg-light-blue {
  background-color: #44d3f4;
}
.border-light-blue {
  border-color: #44d3f4;
}

.text-mid-blue {
  color: #19274c;
}
.bg-mid-blue {
  background-color: #19274c;
}
.border-mid-blue {
  border-color: #19274c;
}

.text-pink {
  color: #e6378f;
}
.bg-pink {
  background-color: #e6378f;
}
.border-pink {
  border-color: #e6378f;
}

.input-group-input-ar {
  border-top-right-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.input-group-text-ar {
  border-top-left-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

body {
  font-family: 'IBM Plex Sans Arabic', Tofu !important;
}
</style>
